import * as CardBenefits from '@/src/experiences/card-benefits'

// Going to update later to make a generic webview that
// takes params and based on params will render expected webview
export default CardBenefits.Screens.MyLowesRewardWebview
